export default __webpack_public_path__ + "static/media/trash.0e372ae3.svg";